import { IMPORTED_DIRPF_ASSET_SOURCE } from "./dirpfImportMeta";

/** Origem padrão quando o backend não envia o campo (cadastro manual). */
export const USER_ASSET_SOURCE = "user" as const;

export type AssetSourceKind = typeof USER_ASSET_SOURCE | typeof IMPORTED_DIRPF_ASSET_SOURCE;

export function normalizeAssetSource(raw: string | undefined | null): AssetSourceKind {
    if (raw === IMPORTED_DIRPF_ASSET_SOURCE) {
        return IMPORTED_DIRPF_ASSET_SOURCE;
    }
    return USER_ASSET_SOURCE;
}
